<template>
  <!--<transition name="anime" enter-active-class="animated slideInRight"-->
              <!--leave-active-class="animated slideOutLeft">-->
    <div class="candidate-pos CandidatePosition.vue full-container yellowjob block">
      <!--<main-menu class="center-logo"></main-menu>-->
      <div class="candidate__content">
        <a href="javascript:void(0);" class="go-back" @click="goCandidateType">
          <arrowBack id="arrow-back"></arrowBack>
        </a>

        <h1 class="title-primary text-center animated fadeInDown delay1000ms">
          Legal <span class="sub"> {{ guestName }}!</span> <br>
          Nos fala mais sobre você:
        </h1>
        <!-- /.title-primary -->

        <div class="clearfix"></div>
        <!-- /.clearfix -->

        <div class="choice-list animated fadeInUp delay1000ms">

          <div class="valid-checks" style="overflow: hidden" v-bind:class="{'animated hide-to-left': candidatePosition==='unknown'}">
            <div class="form-check" v-for="position in positionList">
              <div class="checkbox">
                <label class="form-check-label">
                  <input v-model="candidatePosition" class="form-check-input" type="radio" v-bind:value="position">
                  <span></span>
                  {{position}}
                </label>
              </div><!-- /.checkbox -->
            </div>
          </div>
          <!-- /.valid-checks -->

          <div class="form-check" v-bind:class="{'move-to-top': isUnknownPosition()}">
            <div class="checkbox">
              <label class="form-check-label">
                <input v-model="candidatePosition" class="form-check-input" type="radio" value="unknown">
                <span></span>
                Não sou nada disso, mas tenho certeza que serei muito útil à Bold.
              </label>
            </div><!-- /.checkbox -->
          </div>
          <div class="clearfix"></div>
          <!-- /.clearfix -->
        </div>
        <!-- /.choice-list -->
        <div class="clearfix"></div>
        <!-- /.clearfix -->
        <div class="input-container">
          <div class="form-group unknown-position animated fadeIn delay500ms fake-label" v-if="isUnknownPosition()">
            <!--<p>Então nos fala como...</p>-->
            <!--<textarea class="bold-control"></textarea>-->
            <input id="msg" @keyup="enterKeyPressed" v-fakelabel v-model="candidatePositionCustom" type="text" class="bold-control"
                   placeholder="Então nos fala como..." maxlength="50">
            <label for="msg">Mensagem</label>

          </div>
          <!-- /.form-group -->

          <button @click="validateCandidatePosition()" v-show="isUnknownPosition()" class="btn btn-bold btn-lg animated fadeIn delay500ms">OK <i class="arrow simple"></i></button>
          <!-- /.btn btn-bold -->
        </div>
        <!-- /.input-container -->

      </div>


      <!-- /.content -->
    </div>
  <!--</transition>-->
</template>

<script>
  import MainMenu from './MainMenu.vue'
  import arrowBack from './arrowBack.vue'

  export default {
    name: 'CandidatePosition',
    data() {
      return {
        candidatePosition: '',
        candidatePositionCustom: '',
        positionList: [
          'Sou administrativo/financeiro',
          'Sou atendimento',
          'Sou mídia off-line',
          'Sou mídia online',
          'Sou produtor gráfico e eletrônico',
          'Sou diretor de arte',
          'Sou redator',
          'Sou videomaker',
          'Sou webdesigner',
          'Sou desenvolvedor front-end',
          'Sou desenvolvedor back-end',
        ]
      }
    },
    components: {
      MainMenu,
      arrowBack
    },
    computed: {
      guestName() {
        return this.$store.getters.guestFirstName;
      },
//      candidatePosition: {
//        get() {
//          return this.$store.state.candidate.position;
//        },
//        set(value) {
//          this.$store.commit('setCandidatePosition', value);
//        }
//      }
    },
    mounted() {
      this.log('mounted comp: ' + this.$options.name);
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', 'inverted');
    },
    watch: {
      candidatePosition(newVal, oldVal) {
        if (newVal && newVal !== 'unknown') {
            this.setCandidatePosition(newVal);
        }
      }
    },
    methods: {
      goCandidateType() {
        this.$router.go(-1);
      },
      isUnknownPosition() {
        return this.candidatePosition === 'unknown';
      },
      validateCandidatePosition() {
        let position = this.candidatePositionCustom.replace(/ /g, '');
        if (!position) {
          alert('O campo mensagem é obrigatório!');
          this.candidatePositionCustom = '';
          return;
        }
        this.setCandidatePosition(this.candidatePositionCustom);
      },
      setCandidatePosition(position) {
        this.$store.commit('setCandidatePosition', position);
        window.scroll(0,0)
        this.$router.push('/candidate/contact');
      },
      enterKeyPressed(event) {
        if (event.keyCode === 13) {
          this.validateCandidatePosition();
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/CandidatePosition.vue